import { getSCVisitorId } from '../analytics/dtm_helper';
import ServiceRequestAdapter from '../adapters/service_request.adapter';
import BaseModel from './base.model';

export default class ServiceRequest extends BaseModel {
  static endpoint = 'service-request.json';

  static adapter = ServiceRequestAdapter;

  sc_visitor_id = getSCVisitorId();

  first_name = '';

  last_name = '';

  email = '';

  phone = '';

  zip = '';

  comments = '';

  campaign_name = '';

  agent_number = '';

  recaptcha_response_token = '';

  promiseFetch (options = {}) {
    throw new Error('fetch is not allowed on service requests');
  }

  promiseSave (options = {}) {
    throw new Error('save is not allowed on service requests');
  }

  promiseDestroy (options = {}) {
    throw new Error('destroy is not allowed on service requests');
  }
}
